/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthControllerGetProfile200Response
 */
export interface AuthControllerGetProfile200Response {
    /**
     * 
     * @type {string}
     * @memberof AuthControllerGetProfile200Response
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthControllerGetProfile200Response
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthControllerGetProfile200Response
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthControllerGetProfile200Response
     */
    exp?: number;
}

/**
 * Check if a given object implements the AuthControllerGetProfile200Response interface.
 */
export function instanceOfAuthControllerGetProfile200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthControllerGetProfile200ResponseFromJSON(json: any): AuthControllerGetProfile200Response {
    return AuthControllerGetProfile200ResponseFromJSONTyped(json, false);
}

export function AuthControllerGetProfile200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthControllerGetProfile200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sub': !exists(json, 'sub') ? undefined : json['sub'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'iat': !exists(json, 'iat') ? undefined : json['iat'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
    };
}

export function AuthControllerGetProfile200ResponseToJSON(value?: AuthControllerGetProfile200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sub': value.sub,
        'email': value.email,
        'iat': value.iat,
        'exp': value.exp,
    };
}

